jQuery(document).ready(function ($) {
  // Images
  $('img').each(function () {
    var img = $(this);
    var src = $(this).attr('src');
    var alt = $(this).attr('alt');
    var filename = src.split('/').reverse()[0].replace(/\.[^/.]+$/, '');
    if (img.parent('a').length !== 0) {
      console.log('parent is a link');
      if (alt === '' || alt === undefined) {
        img.attr('alt', 'image ' + filename);
      }
    } else {
      if (alt === '' || alt === undefined) {
        img.attr('alt', '');
      }
    }
  });

  // Tables
  $('main').responsiveTables();

  //Subnav Functionality - START
  $('.subnav span.more').on('click', function () {
    $('.subnav').toggleClass('active');
  });

  $('.subnav span.more').on('keypress', function (e) {
    if (e.which === 13) {
      $('.subnav').toggleClass('active');
      $('.subnav ul li a:last').on('focusout', function () {
        $('.subnav.active').removeClass('active');
      });
    }
  });

  if ($('.subnav ul li').length < 1) {
    $('.subnav').remove();
    $('.banner-wrapper').addClass('no-subnav');
  }
  //Subnav Functionality - END

  //Blog Categories
  $('.blog-category-title').click(function () {
    $('.blog-categories').toggleClass('active');
  });

  $('.blog-category-title').on('keypress', function (e) {
    if (e.which === 13) {
      $('.blog-categories').toggleClass('active');
    }
  });

  //View More for Alternative Accordions List
  $('.accordion-alt-item .read-more').click(function () {
    var $more = $(this).closest('.accordion-alt-item');
    var $toggletext = $(this).closest('.accordion-alt-item .read-more');

    if ($more.hasClass('expanded')) {
      $more.removeClass('expanded');
      $toggletext.text("Read More");
    } else {
      $more.addClass('expanded');
      $toggletext.text("Read Less");
    }
  });

  $('.accordion-alt-item .read-more').on('keypress', function (e) {
    if (e.which === 13) {
      var $more = $(this).closest('.accordion-alt-item');
      var $toggletext = $(this).closest('.accordion-alt-item .read-more');

      if ($more.hasClass('expanded')) {
        $more.removeClass('expanded');
        $toggletext.text("Read More");
      } else {
        $more.addClass('expanded');
        $toggletext.text("Read Less");
      }
    }
  });

  if ($('.alt-options .btn.hide').length) {
    console.log('has hide');
    $('.alt-options .btn.hide').closest('.alt-options').find('.read-more').addClass('no-margin');
  }

  //If there is no H1 in main content section, then make Subpage Banner title an H1
  if ($('.main-content h1').length === 0) {
    $('.banner-wrapper .subpage-title').replaceWith(function () {
      return '<h1>' + $(this).text() + '</h1>';
    });
  }

});